import React from "react";

interface QRCodeIconProps {
  width?: string;
  height?: string;
  color?: string;
  className?: string;
}

export const QRCodeIcon: React.FC<QRCodeIconProps> = ({
  width = 19,
  height = 19,
  color = "white",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25879 6.98065V5.10565C2.25879 3.23815 3.76629 1.73065 5.63379 1.73065H7.50879"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0088 1.73065H13.8838C15.7513 1.73065 17.2588 3.23815 17.2588 5.10565V6.98065"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2588 12.2307V13.3557C17.2588 15.2232 15.7513 16.7307 13.8838 16.7307H12.7588"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50879 16.7307H5.63379C3.76629 16.7307 2.25879 15.2232 2.25879 13.3557V11.4807"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_1936_7128)">
        <path
          d="M13.3213 11.1057H11.8213C11.7177 11.1057 11.6338 11.1896 11.6338 11.2932V12.7932C11.6338 12.8967 11.7177 12.9807 11.8213 12.9807H13.3213C13.4248 12.9807 13.5088 12.8967 13.5088 12.7932V11.2932C13.5088 11.1896 13.4248 11.1057 13.3213 11.1057Z"
          fill={color}
        />
        <path
          d="M11.4463 9.60565H10.3213C10.2177 9.60565 10.1338 9.6896 10.1338 9.79315V10.9182C10.1338 11.0217 10.2177 11.1057 10.3213 11.1057H11.4463C11.5498 11.1057 11.6338 11.0217 11.6338 10.9182V9.79315C11.6338 9.6896 11.5498 9.60565 11.4463 9.60565Z"
          fill={color}
        />
        <path
          d="M14.8213 12.9807H13.6963C13.5927 12.9807 13.5088 13.0646 13.5088 13.1682V14.2932C13.5088 14.3967 13.5927 14.4807 13.6963 14.4807H14.8213C14.9248 14.4807 15.0088 14.3967 15.0088 14.2932V13.1682C15.0088 13.0646 14.9248 12.9807 14.8213 12.9807Z"
          fill={color}
        />
        <path
          d="M14.8213 9.60565H14.0713C13.9677 9.60565 13.8838 9.6896 13.8838 9.79315V10.5432C13.8838 10.6467 13.9677 10.7307 14.0713 10.7307H14.8213C14.9248 10.7307 15.0088 10.6467 15.0088 10.5432V9.79315C15.0088 9.6896 14.9248 9.60565 14.8213 9.60565Z"
          fill={color}
        />
        <path
          d="M11.0713 13.3557H10.3213C10.2177 13.3557 10.1338 13.4396 10.1338 13.5432V14.2932C10.1338 14.3967 10.2177 14.4807 10.3213 14.4807H11.0713C11.1748 14.4807 11.2588 14.3967 11.2588 14.2932V13.5432C11.2588 13.4396 11.1748 13.3557 11.0713 13.3557Z"
          fill={color}
        />
        <path
          d="M14.2588 3.98065H10.8838C10.6849 3.98065 10.4941 4.05967 10.3535 4.20032C10.2128 4.34097 10.1338 4.53174 10.1338 4.73065V8.10565C10.1338 8.30456 10.2128 8.49533 10.3535 8.63598C10.4941 8.77663 10.6849 8.85565 10.8838 8.85565H14.2588C14.4577 8.85565 14.6485 8.77663 14.7891 8.63598C14.9298 8.49533 15.0088 8.30456 15.0088 8.10565V4.73065C15.0088 4.53174 14.9298 4.34097 14.7891 4.20032C14.6485 4.05967 14.4577 3.98065 14.2588 3.98065ZM13.5088 7.16815C13.5088 7.21788 13.489 7.26557 13.4539 7.30073C13.4187 7.3359 13.371 7.35565 13.3213 7.35565H11.8213C11.7716 7.35565 11.7239 7.3359 11.6887 7.30073C11.6535 7.26557 11.6338 7.21788 11.6338 7.16815V5.66815C11.6338 5.61842 11.6535 5.57073 11.6887 5.53557C11.7239 5.50041 11.7716 5.48065 11.8213 5.48065H13.3213C13.371 5.48065 13.4187 5.50041 13.4539 5.53557C13.489 5.57073 13.5088 5.61842 13.5088 5.66815V7.16815ZM8.63379 3.98065H5.25879C5.05988 3.98065 4.86911 4.05967 4.72846 4.20032C4.58781 4.34097 4.50879 4.53174 4.50879 4.73065V8.10565C4.50879 8.30456 4.58781 8.49533 4.72846 8.63598C4.86911 8.77663 5.05988 8.85565 5.25879 8.85565H8.63379C8.8327 8.85565 9.02347 8.77663 9.16412 8.63598C9.30477 8.49533 9.38379 8.30456 9.38379 8.10565V4.73065C9.38379 4.53174 9.30477 4.34097 9.16412 4.20032C9.02347 4.05967 8.8327 3.98065 8.63379 3.98065ZM7.88379 7.16815C7.88379 7.21788 7.86403 7.26557 7.82887 7.30073C7.79371 7.3359 7.74602 7.35565 7.69629 7.35565H6.19629C6.14656 7.35565 6.09887 7.3359 6.06371 7.30073C6.02854 7.26557 6.00879 7.21788 6.00879 7.16815V5.66815C6.00879 5.61842 6.02854 5.57073 6.06371 5.53557C6.09887 5.50041 6.14656 5.48065 6.19629 5.48065H7.69629C7.74602 5.48065 7.79371 5.50041 7.82887 5.53557C7.86403 5.57073 7.88379 5.61842 7.88379 5.66815V7.16815ZM8.63379 9.60565H5.25879C5.05988 9.60565 4.86911 9.68467 4.72846 9.82532C4.58781 9.96597 4.50879 10.1567 4.50879 10.3557V13.7307C4.50879 13.9296 4.58781 14.1203 4.72846 14.261C4.86911 14.4016 5.05988 14.4807 5.25879 14.4807H8.63379C8.8327 14.4807 9.02347 14.4016 9.16412 14.261C9.30477 14.1203 9.38379 13.9296 9.38379 13.7307V10.3557C9.38379 10.1567 9.30477 9.96597 9.16412 9.82532C9.02347 9.68467 8.8327 9.60565 8.63379 9.60565ZM7.88379 12.7932C7.88379 12.8429 7.86403 12.8906 7.82887 12.9257C7.79371 12.9609 7.74602 12.9807 7.69629 12.9807H6.19629C6.14656 12.9807 6.09887 12.9609 6.06371 12.9257C6.02854 12.8906 6.00879 12.8429 6.00879 12.7932V11.2932C6.00879 11.2434 6.02854 11.1957 6.06371 11.1606C6.09887 11.1254 6.14656 11.1057 6.19629 11.1057H7.69629C7.74602 11.1057 7.79371 11.1254 7.82887 11.1606C7.86403 11.1957 7.88379 11.2434 7.88379 11.2932V12.7932Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1936_7128">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(3.75879 3.23065)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QRCodeIcon;
